import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'json2',
  pure: false,
  standalone: true,
})
export class Json2Pipe implements PipeTransform {
  /**
   * @param value A value of any type to convert into a JSON-format string.
   */
  transform(value: unknown): string {
    return JSON.stringify(
      value,
      (key, value) => (Number.isNaN(value) ? 'NaN' : value),
      2
    );
  }
}
